document.querySelectorAll('[data-product-tabs]').forEach((tabs) => {
  if (tabs.dataset.initialized === 'true') return;

  tabs.dataset.initialized = 'true';
  const buttons = Array.from(tabs.querySelectorAll('[data-product-tab]'));
  const panels = Array.from(tabs.querySelectorAll('[data-product-panel]'));

  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      const selectedTab = button.dataset.productTab;

      buttons.forEach((item) => {
        const isSelected = item === button;
        item.setAttribute('aria-selected', String(isSelected));
        item.tabIndex = isSelected ? 0 : -1;
      });

      panels.forEach((panel) => {
        panel.hidden = panel.dataset.productPanel !== selectedTab;
      });
    });
  });
});
